import { Box, Button, Typography } from "@mui/material";
import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";

export default function ContactSpectrum() {
  return (
    <Box
      sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}
    >
      <Typography sx={{ fontWeight: "600", fontSize: 14, color: "#014361" }}>
        Questions? Call Spectrum (801) 461-8200
      </Typography>
      <Button
        sx={{ ml: 1 }}
        variant="text"
        endIcon={<OpenInNewOutlinedIcon />}
        component="a"
        href="https://spectrumfsi.atlassian.net/wiki/external/ZDhhN2M3MTg4MzNlNDk5Njg5ZTkzNTllOWI1OGYyZDM"
        target="_blank"
        rel="noopener noreferrer"
      >
        Region map
      </Button>
    </Box>
  );
}
